module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Renee Ryan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v(" "), _c('Br', [_c('Br', [_c('B', [_vm._v("Renee Ryan")]), _vm._v(" grew up in a Florida beach town outside Jacksonville, FL.  Armed with a degree in Economics and Religion from Florida State University, she explored various career opportunities, including stints at a Florida theme park and a modeling agency. She currently lives in Savannah, Georgia with her husband and a large, fluffy cat many have mistaken for a small bear.  Renee can be contacted through her website at www.reneeryan.com")], 1)], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/aOFlow/tc-custom/9781426828270.jpg?1741153147561",
      "alt": "This image is the cover for the book Marshal Takes a Bride, Charity House"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Marshal Takes a Bride, Charity House\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("U.S. Marshal Trey Scott is fixin' to walk down the aisle just as soon as his stubborn bride-to-be agrees to say \"I do.\" Katherine Taylor's five-year-old sister and an orphanage full of children are depending on her. So why won't the pretty schoolteacher marry him to save her tarnished reputation? Granted, Trey isn't willing to abandon his quest to avenge his first wife's murder. His name alone will protect Katherine until he returns, but she thinks he should leave vengeance to a higher power. Will the sacrifice demanded by the woman he loves be too great to bearor will it be Trey's ultimate redemption?"), _c('br'), _c('br')]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin Enterprises\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0